import { React, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { bg_video } from '../../assets'
import './Connect.css'

export default function Connect() {

  const [windowSize, setWindowSize] = useState(window.innerWidth);

  window.scrollTo(0, 0)

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowSize]);

  return (
    <div className='hero-container'>
    {windowSize > 750 && 
      <video src={bg_video} autoPlay loop muted />
    }
    <h1>CONNECT</h1>
    <p>- Follow the links below -</p>
      <div className='social-icons'>
        <Link
          className='social-icon-link connect'
          to='https://www.linkedin.com/in/owenjrjones/'
          target='_blank'
          aria-label='LinkedIn'
        >
          <i className='fab fa-linkedin' />
        </Link>
        <Link
          className='social-icon-link connect'
          to='https://github.com/owenjrjones/'
          target='_blank'
          aria-label='GitHub'
        >
          <i className='fab fa-github' />
        </Link>
      </div>
    </div>
  )
}
